var _defs, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQuizPremium(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 120 120",
    width: "100%",
    height: "100%",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "iso-shadow",
    x: "-30%",
    y: "-30%",
    width: "160%",
    height: "160%"
  }, /*#__PURE__*/React.createElement("feDropShadow", {
    dx: 0,
    dy: 10,
    stdDeviation: 5,
    floodColor: "#4C1D95",
    floodOpacity: 0.25
  })), /*#__PURE__*/React.createElement("filter", {
    id: "neon-glow-green",
    x: "-30%",
    y: "-30%",
    width: "160%",
    height: "160%"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "blur"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "mainCardGrad",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#7C3AED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#4C1D95"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "glassGrad",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#FFFFFF",
    stopOpacity: 0.9
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#F5F3FF",
    stopOpacity: 0.75
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "correctGrad",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "0%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#10B981"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#059669"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(70, 68) scale(0.9, 0.75) rotate(-30)",
    filter: "url(#iso-shadow)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-15, -35)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -25,
    y: -30,
    width: 50,
    height: 50,
    rx: 8,
    fill: "url(#mainCardGrad)",
    stroke: "#A78BFA",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: -23,
    y: -28,
    width: 46,
    height: 46,
    rx: 6,
    fill: "none",
    stroke: "#C084FC",
    strokeWidth: 1,
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("text", {
    x: 0,
    y: 7,
    fontFamily: "system-ui, sans-serif",
    fontSize: 28,
    fontWeight: 900,
    fill: "#FFFFFF",
    textAnchor: "middle"
  }, "?")), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0, 28)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -35,
    y: -8,
    width: 70,
    height: 16,
    rx: 8,
    fill: "url(#glassGrad)",
    stroke: "#DDD6FE",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: -27,
    cy: 0,
    r: 4,
    fill: "#94A3B8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -18,
    y: -3,
    width: 36,
    height: 5,
    rx: 2.5,
    fill: "#CBD5E1"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-8, -2)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -35,
    y: -8,
    width: 70,
    height: 16,
    rx: 8,
    fill: "url(#glassGrad)",
    stroke: "#EF4444",
    strokeWidth: 1.5,
    strokeOpacity: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    cx: -27,
    cy: 0,
    r: 4.5,
    fill: "#EF4444"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-29,-2 L-25,2 M-25,-2 L-29,2",
    stroke: "#FFFFFF",
    strokeWidth: 1.2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -18,
    y: -3,
    width: 40,
    height: 5,
    rx: 2.5,
    fill: "#FDA4AF"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(10, 13)",
    filter: "url(#neon-glow-green)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -35,
    y: -8,
    width: 70,
    height: 16,
    rx: 8,
    fill: "url(#correctGrad)",
    stroke: "#34D399",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: -27,
    cy: 0,
    r: 5,
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-29,-0.5 L-27,1.5 L-24,-1.5",
    fill: "none",
    stroke: "#10B981",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -18,
    y: -3,
    width: 44,
    height: 6,
    rx: 3,
    fill: "#FFFFFF"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    fill: "#FBBF24",
    opacity: 0.9
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 85,15 L 87,18 L 90,19 L 87,20 L 85,23 L 83,20 L 80,19 L 83,18 Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 22,85 L 24,88 L 27,89 L 24,90 L 22,93 L 20,90 L 17,89 L 20,88 Z",
    transform: "scale(0.8)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuizPremium);
export default __webpack_public_path__ + "static/media/quiz_premium.3221722963640a4cbda4e3c70147d006.svg";
export { ForwardRef as ReactComponent };